import type {ReactElement} from 'react';
import {FontControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-control/font-control';
import type {FormBackgroundFontControlProps} from './form-background-font-control.types';

export function FormBackgroundFontControl({component}: FormBackgroundFontControlProps): ReactElement {
  return <FontControl component={component} />;
}
